import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Import Custom Packages from CSV',
    id: 'wLb00Y',
    description: 'Custom Package Import Drawer Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    defaultMessage: 'Import Custom Packages',
    id: '5Hz4au',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    defaultMessage: 'Custom Packages Successfully Imported',
    id: '8+oanF',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  name: {
    defaultMessage: 'Name',
    id: 'HMTJ/7',
    description: 'Custom package import column name',
  },
  length: {
    defaultMessage: 'Length',
    id: 'RFnpqP',
    description: 'Custom package import column length',
  },
  width: {
    defaultMessage: 'Width',
    id: 'aKKc4x',
    description: 'Custom package import column width',
  },
  height: {
    defaultMessage: 'Height',
    id: 'KHMGgp',
    description: 'Custom package import column height',
  },
  tare_weight: {
    defaultMessage: 'Tare Weight',
    id: 'mu5YXe',
    description: 'Custom package import column tare (empty package) weight',
  },
  max_weight: {
    defaultMessage: 'Max Weight',
    id: '2ondK7',
    description: 'Custom package import column maximum fillable weight',
  },
});
